import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m9.5 2.5-7 7m0-7 7 7"
    }, null, -1)
  ])]);
}
const CloseIcon = { render };
export {
  CloseIcon as default,
  render
};
//# sourceMappingURL=x-close.svg.js.map
